import React,{Component} from  "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Cookies from "cookies-js";
import { Route, Switch } from 'react-router-dom';

import * as profileActions from "../../actions/profileActions";
import * as companiesActions from "../../actions/companiesActions";
import * as configActions from "../../actions/configActions";

import Companies from "../Companies";
import Company from "../Company";
import Admin from "../Admin";
import Dashboard from "../Dashboard";

class Main extends  Component{
    constructor(props) {
        super(props);

        const { profile,profileActions,companiesActions ,configActions} = props;

        let accessToken = Cookies.get("access_token");
        if (!accessToken) {
            profileActions.ProfileGoAuth("/", "");
        }else{
            profileActions.ProfileInit();
            //companiesActions.Get();
            profileActions.ProfileGetRole();
            configActions.GetBindingTypes();
            configActions.GetRegions();
        }
    }
    componentDidUpdate() {
        const { profile } = this.props;

    }
    render(){
        return(
            <Switch>
                <Route exact path="/" component={Companies} />
                <Route path="/company" component={Company} />
                <Route path="/admin" component={Admin} />
                <Route path="/dashboard" component={Dashboard} />
            </Switch>
        )
    }
};


function mapStateToProps(state) {
    return {
        profile: state.profile
    }
}

function mapDispatchToProps(dispath) {
    return {
        profileActions: bindActionCreators(profileActions, dispath),
        companiesActions: bindActionCreators(companiesActions, dispath),
        configActions: bindActionCreators(configActions, dispath),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Main);


// WEBPACK FOOTER //
// ./src/components/Main/index.jsx